import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Form, Button, Message, Icon, Input, Segment, Header, Container, Label } from 'semantic-ui-react';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { auth, db } from '../../utils/firebase';
import { Card } from "semantic-ui-react";
import { ref, set, get } from "firebase/database";
import { translateError } from '../../utils/errors';
import { trackRegistrationEvent } from '../../utils/analytics';
export default function RegistrationDialog({
  intent,
  open,
  onClose,
  onSuccess,
  onLoginClick,
}) {
  const [showAllPackages, setShowAllPackages] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [alias, setAlias] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [successMessage, setSuccessMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);


  const [selectedPackage, setSelectedPackage] = useState(null);

  const handleSelect = (pkgId) => {
    setSelectedPackage(pkgId);
  };


  useEffect(() => {
    if (!open) {
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setErrors([]);
      setSuccessMessage('');
      setShowAllPackages(false);
      setLoading(false);
    }
    if (open) {
      setSelectedPackage('free');
    }
  }, [open]);

  const validate = () => {
    const newErrors = [];

    if (!email) {
      newErrors.push('Email je povinný');
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.push('Zadaj platný email');
    }

    if (password.length < 8) {
      newErrors.push('Heslo musí mať aspoň 8 znakov');
    }

    if (password !== confirmPassword) {
      newErrors.push('Heslá sa nezhodujú');
    }

    if (alias.length < 4 || alias.length > 8) {
      newErrors.push('Alias má mať 4 až 8 znakov.');
    }

    return newErrors;
  };

  const updateAlias = (e) => {
    const newAlias = e.target.value.toUpperCase();
    const validate = (value) => {
      const regex = /^[A-Z0-9]+$/;
      return regex.test(value);
    }

    if (validate(newAlias) || newAlias.length == 0) {
      setAlias(newAlias)
    }
  }

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (validationErrors.length === 0) {
      try {
        localStorage.setItem("ignoreAuthStateChange", true);
        const snapshot = await get(ref(db, 'channels/' + alias));
        if(!!snapshot.val()){
          throw new Error("alias-already-taken")
        }

        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

        await sendEmailVerification(userCredential.user);
        await set(ref(db, "users/" + userCredential.user.uid), {
          email: email,
          alias: alias,
          plan: selectedPackage,
          activePlan: "free"
        });

        await set(ref(db, "channels/" + alias), userCredential.user.uid);

        if (!intent) {
          setSuccessMessage('Poslali sme ti mail, over si ho a si zaregistrovaný.');
          onSuccess(userCredential)
        } else {
          onSuccess(alias)
        }

        localStorage.setItem("ignoreAuthStateChange", false);
        trackRegistrationEvent();

      } catch (error) {
        const errorMessage = translateError(error.message);
        setErrors([errorMessage]);
        setSuccessMessage('');
      }

    } else {
      setErrors(validationErrors);
      setSuccessMessage('');
    }
  };

  const canSubmit = email.trim().length > 3 && password.length > 0 && !loading && alias.trim().length > 3 && alias.trim().length < 9;

  const packages = [
    {
      id: "free",
      name: "Demo",
      description: <>
        <p>Max 10 správ za deň.</p>
        <p>60 dní prístupu.</p>
        <p>Nálepku si vytlačíš.</p>
      </>,
      icon: "address book",
      topLabel: () => (<Label as='a' color={selectedPackage === 'free' ? "green" : "grey"} fluid attached='top left'>ZADARMO</Label>),
      bottomLabel: () => (<Label color={selectedPackage === 'free' ? "yellow" : "grey"} attached='bottom' style={{ width: '100%', marginTop: '1rem', textAlign: 'center' }}>60 dní</Label>)
    },
    // {
    //   id: "basic",
    //   name: "Základ",
    //   description: <>
    //     <p>Max 50 správ za deň.</p>
    //     <p>2 roky prístupu.</p>
    //     <p>Nálepku si vytlačíš.</p>
    //   </>,
    //   icon: "chart bar",
    //   topLabel: () => (<Label as='a' color={selectedPackage === 'basic' ? "red" : "grey"} fluid attached='top left'>19.90 €</Label>),
    //   bottomLabel: () => (<Label color={selectedPackage === 'basic' ? "yellow" : "grey"} attached='bottom' style={{ width: '100%', marginTop: '1rem', textAlign: 'center' }}>2 roky</Label>)
    // },
    {
      id: "premium",
      name: "Premium",
      description: <>
        <p>Max 50 správ za deň.</p>
        <p>3 roky prístupu.</p>
        <p>Nálepku na auto ti pošleme.</p>
      </>,
      icon: "car",
      topLabel: () => (<Label as='a' color={selectedPackage === 'premium' ? "red" : "grey"} fluid attached='top left'>49.90 €</Label>),
      bottomLabel: () => (<Label color={selectedPackage === 'premium' ? "yellow" : "grey"} attached='bottom' style={{ width: '100%', marginTop: '1rem', textAlign: 'center' }}>3 roky</Label>)
    }
  ];

  const renderPackagesWithIntent = () => {
    const visiblePackages = showAllPackages ? packages : [packages[0]];
    return (
      <Card.Group stackable centered itemsPerRow={3}>
        {visiblePackages.map((pkg) => (
          <Card
            onClick={() => handleSelect(pkg.id)}
            key={pkg.id}
            color="black"
            raised={selectedPackage === pkg.id}
          >
            <Card.Content textAlign="center">
              <Card.Header style={{ marginTop: "20px", marginBottom: "10px" }}>{pkg.name}</Card.Header>
              <Icon name={pkg.icon} color={selectedPackage === pkg.id ? "yellow" : "grey"} size="huge" />
              <Card.Description style={{ marginTop: 10 }}>{pkg.description}</Card.Description>
              {pkg.topLabel()}
            </Card.Content>
            <Card.Content extra>
              <div style={{ marginTop: 30 }}></div>
              {pkg.bottomLabel()}
            </Card.Content>
          </Card>
        ))}
      </Card.Group>
    )
  }

  const renderPackages = () => {
    return <Card.Group stackable centered itemsPerRow={3}>
      {packages.map((pkg) => (
        <Card
          onClick={() => handleSelect(pkg.id)}
          key={pkg.id}
          color="black"
          raised={selectedPackage === pkg.id}
        >
          <Card.Content textAlign="center">
            <Card.Header style={{ marginTop: "20px", marginBottom: "10px" }}>{pkg.name}</Card.Header>
            <Icon name={pkg.icon} color={selectedPackage === pkg.id ? "yellow" : "grey"} size="huge" />
            <Card.Description style={{ marginTop: 10 }}>{pkg.description}</Card.Description>
            {pkg.topLabel()}
          </Card.Content>
          <Card.Content extra>
            <div style={{ marginTop: 30 }}></div>
            {pkg.bottomLabel()}
          </Card.Content>
        </Card>
      ))}
    </Card.Group>
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="tiny"
      closeOnDimmerClick={true}
    >
      <Modal.Header>Registrácia</Modal.Header>
      <Modal.Content>
        {!successMessage && intent &&
          <Container style={{ marginBottom: '1rem' }}>
            <Message attached='bottom' warning>
              Ak chceš poslať správu, najprv si vytvor účet.
              <p>Je to <b>zadarmo</b> a veľmi rýchle.</p>
            </Message>
          </Container>
        }
        {!successMessage &&
          <Form>
            <Form.Field required>
              <label>E‑mail</label>
              <Input
                email="email"
                type="email"
                icon="mail"
                iconPosition="left"
                placeholder="napr. jana@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                disabled={loading}
                required
              />
            </Form.Field>

            <Form.Field required>
              <label>Heslo (aspoň 8 znakov)</label>
              <Input
                name="password"
                type='password'
                iconPosition="left"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
                required
                icon={<Icon name="lock" />}
              />
            </Form.Field>

            <Form.Field required>
              <label>Potvrď heslo</label>
              <Input
                type="password"
                iconPosition="left"
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
                required
                icon={<Icon name="lock" />}
              />
            </Form.Field>


            <Form.Field required>
              <label>Alias (4 - 8 znakov)</label>
              <Input
                name="alias"
                type="text"
                icon="qrcode"
                iconPosition="left"
                placeholder="najčastejšie EČV napr. AA123BB"
                value={alias}
                onChange={e => updateAlias(e)}
                autoComplete="email"
                disabled={loading}
                required
              />
            </Form.Field>

            <Segment>
              <Container>
                <Header style={{ textAlign: 'center' }} as='h4'>Zvoľ si verziu</Header>
                {intent ? renderPackagesWithIntent() : renderPackages()}
              </Container>
            </Segment>
            {errors && errors.length !== 0 && (
              <Message negative size="small">
                <Message.Content>
                  {errors.map(e => (<p><Icon name="warning circle" />{e}</p>))}
                </Message.Content>
              </Message>
            )}

            {intent && !showAllPackages &&
              <Button
                type="button"
                basic
                fluid
                size="large"
                style={{ marginTop: 8, marginBottom: 8 }}
                onClick={() => setShowAllPackages(true)}
                content="Zobraz všetky balíky"
              />}

            <Container style={{ marginBottom: '1rem' }}>
              <Message attached='bottom' color='grey'>
                <p>Už máš účet?&nbsp;
                  <button
                    onClick={onLoginClick}
                    className="linklike"
                  >
                    Prihlás sa.
                  </button>
                </p>
              </Message>
            </Container>

            <Button
              type="submit"
              color='yellow'
              fluid
              size="large"
              loading={loading}
              onClick={handleSubmit}
              content={intent ? 'Registrovať a poslať správu' : 'Registrovať'}
            />

            <Button
              type="button"
              basic
              fluid
              size="large"
              disabled={loading}
              onClick={onClose}
              style={{ marginTop: 8 }}
              content="Zrušiť"
            />
          </Form>}
        {successMessage && (
          <Message success>
            <Message.Header>{successMessage}</Message.Header>
            <p>Skontroluj si email a potvrď registráciu.</p>
          </Message>
        )}
      </Modal.Content>

      <style>{`
        @media (max-width: 480px) {
          .ui.modal > .content { padding-top: 1rem; padding-bottom: 1rem; }
          .ui.modal .ui.form .field > label { margin-bottom: .4rem; }
        }
        .ui.dimmer { background-color: rgba(0, 0, 0, 0.5);}
      `}</style>
    </Modal >
  );
}